import React, {
  memo,
  SetStateAction,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import { useRouter } from 'next/router';
import Link from 'next/link';
import { appAuthContext } from 'context/AuthContext';
import useWindowWidth from 'utils/useWindowWidth';
import useOutsideClickHandler from 'utils/useOutsideClickHandler';
import NavItems from 'components/Header/components/NavItems';
import MobileNavigation from 'components/Header/components/MobileNavigation';
import Button from 'components/Button';
import ProfileDropdown from 'components/Header/components/ProfileDropdown';
import useClickStreamEvent from 'utils/clickstream/useClickStreamEvent';
import useFormattedName from 'utils/useFormattedName';
import Search from '../Search';
import styles from './OldHeader.module.css';

type OldHeaderProps = {
  showSearch: boolean;
  setShowSearch: (show: SetStateAction<boolean>) => void;
  setShowAskModal: (show: SetStateAction<boolean>) => void;
  setShowRegModal: (show: SetStateAction<boolean>) => void;
  unanswered: number | null;
  userAuth: boolean;
  setShowLogoutModal: (show: SetStateAction<boolean>) => void;
};
const OldHeader = memo(function OldHeader({
  showSearch,
  setShowSearch,
  setShowAskModal,
  setShowRegModal,
  unanswered,
  userAuth,
  setShowLogoutModal,
}: OldHeaderProps) {
  const { sendEvent } = useClickStreamEvent();
  const { user } = useContext(appAuthContext);
  const desktopDropdownRef = useRef(null);
  const windowWidth = useWindowWidth();
  const router = useRouter();
  const formattedName = useFormattedName();

  const [showDropdown, setShowDropdown] = useState<boolean>(false);

  const hasUnreadAnswer = user?.unwatchedQuestions || false;

  useEffect(() => {
    sendEvent({
      eventType: 'display',
      eventInfo: 'otvety_header_unauth_old',
    });
  }, []);

  useEffect(() => {
    setShowDropdown(false);
  }, [router]);

  const showDropdownHandler = () => {
    setShowDropdown(!showDropdown);
  };

  useOutsideClickHandler(desktopDropdownRef, () => setShowDropdown(false));

  return (
    <>
      <div className={styles.container}>
        <div className={styles.header__left}>
          <Link href="/">
            <a className={styles.header__logo} data-qa-marker="header_logo" />
          </Link>
          <div className={styles.header__nav}>
            <div className={styles.header__nav_content}>
              <>
                {!showSearch && windowWidth > 1023 && (
                  <NavItems
                    type="desktop"
                    unanswered={unanswered || null}
                    setShowSearch={setShowSearch}
                  />
                )}
                {windowWidth < 1023 && (
                  <MobileNavigation
                    setShowAskModal={setShowAskModal}
                    setShowRegModal={setShowRegModal}
                    unanswered={unanswered || null}
                    showSearch={showSearch}
                    setShowSearch={setShowSearch}
                  />
                )}
              </>
            </div>
          </div>
        </div>
        {!showSearch && windowWidth > 1023 && (
          <div className={styles.header__not_authorized}>
            {!userAuth ? (
              <Button
                type="transparent"
                text="Войти"
                onClick={() => setShowRegModal(true)}
                addStyles={{ marginRight: '40px', fontSize: '15px' }}
                qaMarker="login_btn"
              />
            ) : (
              <div ref={desktopDropdownRef}>
                <div
                  className={styles.user}
                  onClick={() => showDropdownHandler()}
                  data-qa-marker="pers_menu"
                >
                  <div className={styles.user__avatar_container}>
                    <img className={styles.user__avatar} src={user?.avatar} alt="" />
                    {hasUnreadAnswer ? <div className={styles.user__bell} /> : null}
                  </div>
                  <span className={styles.user__name}>{formattedName}</span>
                </div>
                {showDropdown && (
                  <ProfileDropdown
                    show={showDropdown}
                    showLogoutModal={() => setShowLogoutModal(true)}
                    bell={hasUnreadAnswer}
                    setShowDropdown={setShowDropdown}
                  />
                )}
              </div>
            )}
            <Button
              text="Задать вопрос"
              onClick={() => setShowAskModal(true)}
              addStyles={{ fontSize: '13px' }}
              qaMarker="new_question_open_modal"
            />
          </div>
        )}
      </div>
      {showSearch && windowWidth > 1023 && <Search setShowSearch={setShowSearch} />}
    </>
  );
});

export default OldHeader;
